import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  Grid,
  Typography,
  Chip,
  IconButton,
  Box
} from '@mui/material';
import {
  Assignment as AssignmentIcon,
  Edit as EditIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon
} from '@mui/icons-material';
import { ZulassungsantragResponse, getAntragstellerTypLabel, getGeschaeftsvorfallTypLabel } from '../../types/antrag';

interface GrunddatenCardProps {
  antrag: ZulassungsantragResponse;
  onEdit: () => void;
  getStatusColor: (status: string) => "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning";
  formatDate: (dateString: string) => string;
  vollmachtExists?: boolean;
  sepaExists?: boolean;
}

const GrunddatenCard: React.FC<GrunddatenCardProps> = ({
  antrag,
  onEdit,
  getStatusColor,
  formatDate,
  vollmachtExists,
  sepaExists
}) => {
  return (
    <Card elevation={2} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardHeader
        avatar={<AssignmentIcon />}
        title="Grunddaten"
        subheader="Allgemeine Informationen zum Antrag"
        action={
          <IconButton 
            onClick={onEdit}
            size="small"
            color="primary"
          >
            <EditIcon />
          </IconButton>
        }
      />
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="body2" color="textSecondary">
              Kunde:
            </Typography>
            <Typography variant="body1" fontWeight="bold">
              {antrag.kunde.name}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" color="textSecondary">
              Geschäftsvorfall:
            </Typography>
            <Typography variant="body1">
              {getGeschaeftsvorfallTypLabel(antrag.geschaeftsvorfallTyp)}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" color="textSecondary">
              Zulassung auf:
            </Typography>
            <Typography variant="body1">
              {antrag.antragstellerTyp ? getAntragstellerTypLabel(antrag.antragstellerTyp) : '-'}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2" color="textSecondary">
              Status:
            </Typography>
            <Chip 
              label={antrag.status} 
              color={getStatusColor(antrag.status)}
              size="small"
            />
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" color="textSecondary">
              Erstellt:
            </Typography>
            <Typography variant="body1">
              {formatDate(antrag.erstelltAm)}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" color="textSecondary">
              Aktualisiert:
            </Typography>
            <Typography variant="body1">
              {formatDate(antrag.aktualisiertAm)}
            </Typography>
          </Grid>
          
          {/* Dokumentenstatus - kompakte Darstellung */}
          <Grid item xs={12}>
            <Typography variant="body2" color="textSecondary" sx={{ mb: 0.5 }}>
              Dokumente:
            </Typography>
            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
              <Chip
                icon={vollmachtExists ? <CheckCircleIcon /> : <CancelIcon />}
                label="Vollmacht"
                color={vollmachtExists ? 'success' : 'default'}
                size="small"
                variant="outlined"
              />
              <Chip
                icon={sepaExists ? <CheckCircleIcon /> : <CancelIcon />}
                label="SEPA"
                color={sepaExists ? 'success' : 'default'}
                size="small"
                variant="outlined"
              />
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default GrunddatenCard;
